// @ts-check

import React from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** @param {import('@liquidweb-dev/undercurrent/Stack').StackProps} props */
const RestrictionWrapper = ({ sx, ...rest }) => {
	return (
		<Stack
			sx={combineSx(
				({ vars }) => ({
					alignItems: 'center',
					justifyContent: 'center',
					paddingX: 200,
					background: `linear-gradient(165deg, ${vars.palette.uc.bg.main} 10.48%, ${vars.palette.uc.highlight.bg.weak} 55.27%, #E3E1FD 115.69%)`,
				}),
				sx,
			)}
			{...rest}
		/>
	);
};

export default RestrictionWrapper;
